import React from 'react';
import '../LikeLoaderShimmer/styles.css';
import '../QuestionBankShimmer/styles.css';

const CommentShimmer = () =>
{
	return (
		<div className='flexCol whiteBg'>
			<div className='cardT car-cont bg-white when-NOW p2p style-scope animated_skelton-animate'>
				{[ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11 ].map((e) => (
					<div className='row cab-row style-scope animated_skelton-animate' key={e}>
						<div className='left cab-icon label style-scope animated_skelton-animate'>
							<div className='icon-placeholder shimmer style-scope animated_skelton-animate' />
						</div>
						<div className='middle holder style-scope animated_skelton-animate'>
							<div className='text2Header-placeholder shimmer style-scope animated_skelton-animate' />
							<div className='text-placeholder shimmer style-scope animated_skelton-animate' />
						</div>
					</div>
				))}

			</div>
			<div className='flexCol pdngSM'>
				<div className='shimmerHeader loading-shimmer' />
			</div>
		</div>
	);
};

export default CommentShimmer;
